import { createContext, useContext } from 'react';
import { NotificationContextValue } from '../types';

export const NotificationContext = createContext<NotificationContextValue>(undefined!);

export const useNotificationContext = () => {
  return useContext(NotificationContext);
};
